import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from '../utils/apiEndpoints';
import { problemPath } from '../utils/problemUrls.ts';
import { useTranslation } from '../contexts/TranslationContext.tsx';

type Props = {
  problemId: string;
};

/**
 * Редирект со старых URL /problems/:id → /problems/:topic/:slug
 */
function LegacyProblemRedirect({ problemId }: Props) {
  const navigate = useNavigate();
  const { currentLanguage, t } = useTranslation();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      if (!problemId || !/^\d+$/.test(problemId)) {
        navigate('/404', { replace: true });
        return;
      }
      try {
        const lang = currentLanguage || 'en';
        const response = await fetch(
          `${API_BASE}/api/problems/problems_get/${problemId}?lang=${encodeURIComponent(lang)}`,
          { credentials: 'include' }
        );
        if (!response.ok) {
          if (!cancelled) navigate('/404', { replace: true });
          return;
        }
        const data = await response.json();
        if (cancelled) return;
        navigate(problemPath(data), { replace: true });
      } catch {
        if (!cancelled) setError(t('problemPage.unknownError'));
      }
    };
    void run();
    return () => {
      cancelled = true;
    };
  }, [problemId, currentLanguage, navigate, t]);

  if (error) {
    return (
      <div className="problems-list-page" style={{ padding: '2rem', textAlign: 'center' }}>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div className="problems-list-page" style={{ padding: '2rem', textAlign: 'center' }}>
      <p>{t('problemsList.loading')}</p>
    </div>
  );
}

export default LegacyProblemRedirect;
